module.exports = __webpack_public_path__ + "static/media/icon_success.ae38b326.svg";